import { NextGenImage } from '@/components/NextGenImage';

const brands = [
  { name: 'Castrol', logo: '/assets/brands/castrol-logo.png' },
  { name: 'CoolDrive Auto Parts', logo: '/assets/brands/cooldrive-logo.png' },
  { name: 'Capricorn', logo: '/assets/brands/capricorn-logo.png' },
  { name: 'Repco', logo: '/assets/brands/repco-logo.png' },
  { name: 'HSY', logo: '/assets/brands/hsy-logo.png' },
  { name: 'Bosch', logo: '/assets/brands/bosch-logo.png' },
  { name: 'ATE', logo: '/assets/brands/ate-logo.png' },
  { name: 'Penrite', logo: '/assets/brands/penrite-logo.png' },
  { name: 'Bendix', logo: '/assets/brands/bendix-logo.png' },
  { name: 'Liqui Moly', logo: '/assets/brands/liqui-moly-logo.png' },
];

export const LogoMarquee = () => {
  return (
    <section className="py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Trusted Partners & Suppliers
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We work with Australia's leading automotive brands to ensure quality parts and supplies for your vehicle
          </p>
        </div>
      </div>

      <div className="w-full overflow-hidden">
        <div className="flex animate-marquee-infinite">
          {/* First set of brands */}
          {brands.map((brand, index) => (
            <div key={`first-${index}`} className="flex-shrink-0 mx-6 w-36 h-20 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl shadow-sm border border-border/50 p-3 hover:shadow-lg hover:bg-white transition-all duration-300 group">
              <NextGenImage
                src={brand.logo}
                alt={`${brand.name} logo - trusted automotive partner`}
                className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                width={120}
                height={60}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
          {/* Duplicate set for seamless infinite scroll */}
          {brands.map((brand, index) => (
            <div key={`second-${index}`} className="flex-shrink-0 mx-6 w-36 h-20 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-xl shadow-sm border border-border/50 p-3 hover:shadow-lg hover:bg-white transition-all duration-300 group">
              <NextGenImage
                src={brand.logo}
                alt={`${brand.name} logo - trusted automotive partner`}
                className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                width={120}
                height={60}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};